const WHATSAPP_URL = "https://wa.me/556193761185?text=Ol%C3%A1!%20Vim%20pelo%20site%20e%20gostaria%20de%20um%20or%C3%A7amento.";

const STEPS = [
  {
    num: "01",
    title: "Você conta sua ideia",
    text: "Manda o tema, a data e o espaço no WhatsApp. Se ainda não tem tema, a gente ajuda a escolher.",
  },
  {
    num: "02",
    title: "Recebe o projeto e o orçamento",
    text: "Você vê o que vai receber antes de fechar. Sem surpresa no dia.",
  },
  {
    num: "03",
    title: "A gente monta",
    text: "Chegamos antes, montamos tudo e entregamos o cenário pronto pra foto.",
  },
  {
    num: "04",
    title: "E desmontamos",
    text: "Acabou a festa, o problema não é seu. A gente recolhe tudo.",
  },
];

export default function HowItWorks() {
  return (
    <section data-testid="how-it-works-section" className="py-24 bg-[#f9f9f9]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <span className="text-[#00929A] text-xs tracking-[0.25em] uppercase font-medium">Processo</span>
          <h2
            className="text-3xl sm:text-4xl font-light text-[#1a1a1a] tracking-tight mt-3"
            style={{ fontFamily: "Outfit, sans-serif" }}
          >
            Como Funciona
          </h2>
          <div className="w-12 h-0.5 bg-[#00929A] mx-auto mt-4" />
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {STEPS.map((step, i) => (
            <div
              key={i}
              className="relative bg-white rounded-3xl p-8 hover-lift"
              data-testid={`how-step-${i}`}
            >
              <span
                className="text-5xl font-light tracking-tight text-[#E4077B]/15 block mb-4"
                style={{ fontFamily: "Outfit, sans-serif" }}
              >
                {step.num}
              </span>
              <h3
                className="text-lg font-medium text-[#1a1a1a] mb-3"
                style={{ fontFamily: "Outfit, sans-serif" }}
              >
                {step.title}
              </h3>
              <p className="text-[#555555] text-sm leading-relaxed">{step.text}</p>
              {i < STEPS.length - 1 && (
                <div className="hidden lg:block absolute -right-4 top-1/2 -translate-y-1/2 text-[#E4DCCC] text-2xl">
                  &rarr;
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="how-it-works-cta"
            className="inline-flex items-center justify-center bg-[#E4077B] hover:bg-[#c8066a] text-white px-8 py-3.5 rounded-full text-sm font-medium transition-all duration-300 hover:shadow-lg hover:shadow-[#E4077B]/20"
          >
            Falar com Amine no WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}
